// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1LBkl","col":"styles_col__2lC8M","fulfillmentStatus":"styles_fulfillmentStatus__AQQTn","emailCol":"styles_emailCol__3a_Rs"};